import {
    PalettenClusterSorted,
    PalettenEintragFromDBWithFarbgruppenEinteilung
} from "@k/js/databaseInterfaceClasses";
import {Ref} from "vue";
import {ColorUtilsVue} from "@km/js/ColorUtilsVue";

export class ColorGroupSelectionFuncions {

    private static getColorsToDisplayFromSortedPalette(sortedPalette:PalettenEintragFromDBWithFarbgruppenEinteilung[][]):PalettenEintragFromDBWithFarbgruppenEinteilung[] {

        const colorsToDisplay = [] as PalettenEintragFromDBWithFarbgruppenEinteilung[];
        for (const groupID in sortedPalette) {
            if (typeof (sortedPalette[groupID].sort) !== "function") {
                continue;
            }
            sortedPalette[groupID] = sortedPalette[groupID].sort(
                (c1, c2) => c1.farbGruppeUndPosition.positionInGruppe < c2.farbGruppeUndPosition.positionInGruppe ? -1 : 1
            );
            const middle = Math.ceil(sortedPalette[groupID].length / 2);
            colorsToDisplay.push((sortedPalette[groupID][middle - 1]));

        }
        return colorsToDisplay;
    }

    public static getColorGroupRepresentativePalettenEntries(palettenClusterSorted: PalettenClusterSorted | null): PalettenEintragFromDBWithFarbgruppenEinteilung[] {
        if (palettenClusterSorted === null) {
            return [];
        }
        let colors = [] as PalettenEintragFromDBWithFarbgruppenEinteilung[];
        if (typeof (palettenClusterSorted["noColor"]) !== "undefined") {
            colors = colors.concat(ColorGroupSelectionFuncions.getColorsToDisplayFromSortedPalette(palettenClusterSorted["noColor"]));
        }
        for (const palettenName in palettenClusterSorted) {
            if (palettenName !== "noColor") {
                colors = colors.concat(ColorGroupSelectionFuncions.getColorsToDisplayFromSortedPalette(palettenClusterSorted[palettenName]))
            }
        }
        return colors;
    }

    public static getCurrentActiveColorGroup(currentColorValueIntOrNONEstring:string|number|null, palettenCluster:PalettenClusterSorted|null, currentpalette:string|null|undefined) {
        if(currentpalette === undefined || currentpalette === null || currentpalette === "" || palettenCluster === null) {
            return -1;
        }
        if (currentColorValueIntOrNONEstring === null || currentColorValueIntOrNONEstring === "<none>") {
            return -1;
        }
        const foundColor = ColorUtilsVue.getColorPositionInfoForIntValue(currentColorValueIntOrNONEstring, palettenCluster, currentpalette);
        return foundColor !== null ? foundColor.gruppenIndex : -1;


    }
}
